import { createContext, PropsWithChildren, useContext } from 'react';

import { useSingleClaimProvider } from './useSingleClaimProvider';

type SingleClaimData = ReturnType<typeof useSingleClaimProvider>;

const SingleClaimContext = createContext({} as SingleClaimData);

export const SingleClaimProvider = ({ children }: PropsWithChildren<{}>) => {
  const value = useSingleClaimProvider();
  return (
    <SingleClaimContext.Provider value={value}>
      {children}
    </SingleClaimContext.Provider>
  );
};

export const useSingleClaimContext = () =>
  useContext<SingleClaimData>(SingleClaimContext);
